<template>
  <v-form ref="form" class="form">
    <v-row>
      <v-col class="py-0" cols="12">
        <v-text-field
          v-model="tariff.name"
          :label="$t('tariffs.name')"
          :loading="resourceLoading"
          :rules="
            resourceLoading ? [] : [rules.required, backEndValidation('name')]
          "
          :readonly="readonly"
        ></v-text-field>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-combobox
          :items="symbols.map(i => i.symbol)"
          v-model="tariff.unit_symbol"
          :label="$t('tariffs.unit-symbol')"
          :loading="resourceLoading"
          :rules="resourceLoading ? [] : [backEndValidation('unit_symbol')]"
          :readonly="readonly"
        ></v-combobox>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-autocomplete
          v-model="tariff._tariff_plan.id"
          :items="tariffPlans"
          item-text="name"
          item-value="id"
          :label="$t('tariffs.tariff-plan')"
          :loading="resourceLoading"
          :rules="
            resourceLoading
              ? []
              : [rules.requiredWithNull, backEndValidation('tariff_plan_id')]
          "
          :readonly="readonly"
        ></v-autocomplete>
      </v-col>
      <v-col class="py-0" cols="12">
        <v-switch
          v-model="tariff.export"
          :label="$t('tariffs.export')"
          color="primary"
          :loading="resourceLoading"
          :readonly="readonly"
        ></v-switch>
      </v-col>
    </v-row>

    <v-btn
      color="primary mr-3"
      v-on:click="save()"
      :loading="loading"
      :disabled="readonly"
    >
      <v-icon left>{{ $props.button_icon }}</v-icon>
      {{ $t(`tariffs.${$props.button_title}`) }}
    </v-btn>
  </v-form>
</template>

<script>
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "FormTariff",
  mixins: [rules, projectPermissions],
  data: () => ({
    loading: false
  }),
  props: {
    dispatch: String,
    button_title: String,
    button_icon: String,
    tariff: {
      default: function() {
        return {
          _tariff_plan: { id: null }
        };
      }
    },
    resourceLoading: {
      type: Boolean,
      default: false
    },
    permission: {
      type: String,
      default: ""
    }
  },
  computed: {
    symbols() {
      return this.$store.getters["presetStore/getSymbolPreset"];
    },
    tariffPlans() {
      const tariffPlanObject = this.$store.getters[
        "projectMeteringStore/tariffPlanStore/getList"
      ];
      if (tariffPlanObject) {
        const tariffPlansArray = Object.values(tariffPlanObject);
        return tariffPlansArray;
      } else {
        return [];
      }
    },
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions(this.permission);
      }
    }
  },
  methods: {
    save() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let item = {
          ...this.tariff,
          id: this.$route.params.id,
          project_id: this.$route.params.project_id,
          name: this.tariff ? this.tariff.name : null,
          unit_symbol: this.tariff ? this.tariff.unit_symbol : null
        };
        this.$store
          .dispatch(this.$props.dispatch, {
            item,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  mounted() {
    this.$store.dispatch("projectMeteringStore/tariffPlanStore/getList", {
      params: { limit: -1, project_id: this.$route.params.project_id }
    });
  }
};
</script>
